// 🚨 Page facture publique : lien remplacé → explication + demande d'un nouveau lien (réponse neutre côté serveur).
import { useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

export function LienRemplace({ factureId, message, typeApi = 'crm/factures' }) {
  const [etat, setEtat] = useState('idle');
  const [reponse, setReponse] = useState('');
  const demander = async () => {
    setEtat('envoi');
    try {
      const res = await fetch(`${API_URL}/api/${typeApi}/${factureId}/demander-nouveau-lien`, { method: 'POST' });
      const d = await res.json().catch(() => ({}));
      setReponse(res.ok ? (d.message || 'Si cette facture existe, un nouveau lien a été envoyé au courriel au dossier.') : (d.detail || 'Trop de demandes — réessayez plus tard.'));
      setEtat(res.ok ? 'ok' : 'erreur');
    } catch {
      setReponse('Impossible de joindre le serveur — réessayez dans un instant.'); setEtat('erreur');
    }
  };
  return (
    <div className="bg-white rounded-xl p-8 text-center shadow-sm max-w-md w-full" data-testid="facture-publique-lien-remplace">
      <p className="text-lg font-semibold text-slate-800">{message || 'Ce lien a été remplacé pour renforcer la sécurité — recevez un nouveau lien par courriel.'}</p>
      {typeApi && etat !== 'ok' && (
        <button type="button" onClick={demander} disabled={etat === 'envoi'} className="mt-5 px-5 py-2.5 rounded-lg bg-slate-900 text-white text-sm font-medium disabled:opacity-50" data-testid="facture-publique-demander-lien">
          {etat === 'envoi' ? 'Envoi…' : 'Recevoir un nouveau lien par courriel'}
        </button>
      )}
      {reponse && <p className={`mt-4 text-sm ${etat === 'ok' ? 'text-emerald-700' : 'text-red-600'}`} data-testid="facture-publique-lien-reponse">{reponse}</p>}
    </div>
  );
}
